import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-card-type-3',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './card-type-3.component.html',
    styleUrl: './card-type-3.component.scss',
})
export class CardType3Component {
    @Input() image!: string;
    @Input() title!: string;
    @Input() gaPrefix!: string;
    @Input() buttonText: string;
    @Input() url!: string;
    @Output() buttonClick = new EventEmitter<void>();
    ga: any = {
        id: '',
        label: '',
        category: 'JC3 Button Click',
    };

    ngOnInit(): void {
        let slug = this.title?.toLowerCase()?.replaceAll(' ', '_');
        this.ga.id = this.gaPrefix + slug + '_button_jc3_click';
        this.ga.label = this.gaPrefix.replaceAll('_', ' ');
    }

    onButtonClick() {
        this.buttonClick.emit();
    }
}
